import { render, staticRenderFns } from "./warning-dialog.vue?vue&type=template&id=4ed57d0a"
import script from "./warning-dialog.vue?vue&type=script&lang=js"
export * from "./warning-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports